/**
 * Created by Victor Rojo on 17/11/17.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import {CloudUseriPlace} from "../model/cloudUseriPlace";

@Injectable()
export class CloudUserIPlaceService{

  private basePath = "api/v1/cloud_user_iplace/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  get(): Promise<any>{
    let url = this.basePath;
    return this.http.get(url)
      .toPromise()
      .then( res => res as CloudUseriPlace[])
      .catch( error => this.errorHandler(error) );
  }

}
